<script lang="ts">
  import type { OneColComponent } from "$lib/js/strapi/types";
  import '$lib/css/components/rich-text.scss'

  export let component : OneColComponent
</script>


<div class="one-col">
  <div class="one-col__inner">
    {#if component.title}
      <h2>{@html component.title}</h2>
    {/if}

    {#if component.content}
      <div class="u-rich-text">{@html component.content}</div>
    {/if}
  </div>
</div>


<style lang="scss">
  .one-col {
    margin: 25px 0;
    max-width: 850px;

    @media (min-width: 769px) {
      margin: 50px 0;
    }

    p {
      color: black;

      @media (min-width: 769px) {
        font-size: 16px;
        line-height: 1.3;
      }
    }
  }
</style>
